export class FnFileConstant {
    public static readonly FILE_TYPE_ICONS:any = {
        image: 'fn-global-image blue',
        video: 'fn-global-videoFile blue',
        audio: 'fn-global-audioFile blue',
        word: 'fn-global-word blue',
        excel: 'fn-global-excel green',
        powerpoint: 'fn-global-powerpoint red',
        text: 'fn-global-file black',
        pdf: 'fn-global-pdf red',
        zip: 'fn-global-zip yellow',
        json: 'fn-global-json blue',
        other: 'fn-global-file black',
    };
    public static readonly FILE_TYPES:any = {
        pdf: 'pdf',
        excel: '|vnd.ms-excel|vnd.openxmlformats-officedocument.spreadsheetml.sheet|vnd.openxmlformats-officedocument.spreadsheetml.template|comma-separated-values|vnd.msexcel|excel|',
        powerpoint: '|vnd.ms-powerpoint|vnd.openxmlformats-officedocument.presentationml.presentation|vnd.openxmlformats-officedocument.presentationml.template|vnd.openxmlformats-officedocument.presentationml.slideshow|',
        text: '|rtf|x-rtf|richtext|txt|csv',
        word: '|msword|vnd.openxmlformats-officedocument.wordprocessingml.document|vnd.openxmlformats-officedocument.wordprocessingml.template|',
        zip: '|x-compressed|x-compress|x-rar-compressed|zip|x-tar|x-compressed-zip|',
    };
    public static readonly BASE_TYPES:any = '|image|video|audio|text|';
}


